import { render, staticRenderFns } from "./comparedropdown.vue?vue&type=template&id=267cf8fa"
import script from "./comparedropdown.vue?vue&type=script&lang=js"
export * from "./comparedropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\_\\glatzb2c_2022\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('267cf8fa')) {
      api.createRecord('267cf8fa', component.options)
    } else {
      api.reload('267cf8fa', component.options)
    }
    module.hot.accept("./comparedropdown.vue?vue&type=template&id=267cf8fa", function () {
      api.rerender('267cf8fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "common/elements/siteheaderstandard/assets/frontend/components/comparedropdown.vue"
export default component.exports